import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

 const swiper = new Swiper('.block-majesco-awards-slider__inner', {
 	// configure Swiper to use modules
	modules: [Navigation],
	loop: false,
	slidesPerView: 'auto',
	//centeredSlides: true,
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	spaceBetween: 8,
	breakpoints: {
		782: {
			spaceBetween: 24,
			centeredSlides: false,
			centerInsufficientSlides: true
		}
	}
	//centerInsufficientSlides: true
});

 const hotTopicsSwiper = new Swiper('.block-majesco-hot-topic-slider__inner', {
	 // configure Swiper to use modules
	modules: [Navigation],
	loop: false,
	slidesPerView: 'auto',
	//centeredSlides: true,
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	spaceBetween: 8,
	breakpoints: {
		782: {
			spaceBetween: 24
		}
	}
});

var homeSliders = document.querySelectorAll('.wp-block-majesco-home-slider'),
	defaultOptions = {
		modules: [Navigation, Pagination, Autoplay],
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets'
		},
		loop: true,
		watchOverflow: true
	};

[].forEach.call(homeSliders, function( slider, index, arr )
{
	var data = slider.getAttribute('data-swiper') || {};
	var slideCount = slider.querySelectorAll('.swiper-slide');

	if (data)
	{
		var dataOptions = JSON.parse(data);
	}

	slider.options = Object.assign({}, defaultOptions, dataOptions);

	if( slideCount.length < 2 ){
		slider.options.autoplay = false;
		slider.options.navigation = false;
		slider.querySelector('.swiper-button-prev').style.display = 'none';
		slider.querySelector('.swiper-button-next').style.display = 'none';
	}

	var swiper = new Swiper(slider, slider.options);

	/* stop on hover */
	if ( typeof slider.options.autoplay !== 'undefined' && slider.options.autoplay !== false )
	{
		slider.addEventListener('mouseenter', function(e) {
			swiper.autoplay.stop();
		});

		slider.addEventListener('mouseleave', function(e) {
			swiper.autoplay.start();
		});
	}
});

const featuredCustomersSwiper = new Swiper('.block-majesco-featured-customers__inner', {
	 // configure Swiper to use modules
	modules: [Navigation],
	loop: true,
	slidesPerView: 'auto',
	//centeredSlides: true,
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	spaceBetween: 8,
	breakpoints: {
		782: {
			spaceBetween: 24
		}
	}
});

const testimonialSwiper = new Swiper('.block-majesco-testimonial-slider__inner', {
	modules: [Navigation, Pagination, Autoplay],
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true
	},
	loop: false,
	spaceBetween: 60
});
//testimonialSwiper.autoplay.start();

// Solutions Section Pages Intro Section Slider
var solutionIntroSliders = document.querySelectorAll('.wp-block-majesco-solution-intro-slider'),
	defaultOptions = {
		modules: [Pagination, Autoplay],
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},
		loop: true,
		watchOverflow: true
	};
[].forEach.call(solutionIntroSliders, function( slider, index, arr )
{
	var data = slider.getAttribute('data-swiper') || {};
	var slideCount = slider.querySelectorAll('.wp-block-majesco-solution-intro-slide');

	if (data)
	{
		var dataOptions = JSON.parse(data);
	}

	slider.options = Object.assign({}, defaultOptions, dataOptions);

	if( slideCount.length < 2 ){
		slider.options.autoplay = false;
		slider.options.navigation = false;
		slider.querySelector('.swiper-button-prev').style.display = 'none';
		slider.querySelector('.swiper-button-next').style.display = 'none';
	}

	var swiper = new Swiper(slider, slider.options);

	/* stop on hover */
	if ( typeof slider.options.autoplay !== 'undefined' && slider.options.autoplay !== false )
	{
		slider.addEventListener('mouseenter', function(e) {
			swiper.autoplay.stop();
		});

		slider.addEventListener('mouseleave', function(e) {
			swiper.autoplay.start();
		});
	}
});

 const photoGridGallerySliderSwiper = new Swiper('.photo-grid-gallery-slider-swiper', {
	 // configure Swiper to use modules
	modules: [Navigation],
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	loop: true
});
const photoGridGallery = document.getElementById('block-majesco-photo-grid-gallery-slider__grid');
if( photoGridGallerySliderSwiper && photoGridGallery ){
	const photos = photoGridGallery.querySelectorAll('a');
	photos.forEach( photo => {
		photo.addEventListener( 'click', e => {
			const slideTo = e.currentTarget.dataset.slideTo;
			photoGridGallerySliderSwiper.slideTo( slideTo, 0, true );
		});
	});
}

 const diversityCardsSwiper = new Swiper('.block-majesco-diversity-cards-slider__inner', {
	 // configure Swiper to use modules
	modules: [Navigation],
	loop: false,
	slidesPerView: 'auto',
	//centeredSlides: true,
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	spaceBetween: 8,
	breakpoints: {
		782: {
			spaceBetween: 37,
			centeredSlides: false,
			centerInsufficientSlides: true
		}
	}
	//centerInsufficientSlides: true
});
